@if (menuItems().length > 0) {
  <div
    class="main-menu"
    [class.expanded]="isExpanded()"
    [class.double]="menuItemsSecondary().length > 0"
  >
    @if (mainMenuCanToggle()) {
      <div class="toggle" (click)="toggleSidebar()">
        <a
          ><fa-icon
            [icon]="!isRtl() ? ['fas', 'arrow-right'] : ['fas', 'arrow-left']"
          ></fa-icon
        ></a>
      </div>
    }
    <div class="app-menu">
      <!-- Company Section -->
      @if (hasUser) {
        <div class="module" [class.border-bottom]="!isExpanded()">
          <app-module-switch
            [showActiveInfo]="isExpanded()"
          ></app-module-switch>
        </div>
      }
      <!-- Search Section -->
      @if (isExpanded()) {
        <app-search-input
          (inputChanged)="onSearchChange($event)"
        ></app-search-input>
      }
      <!-- Back Button -->
      @if (hasBackButton) {
        <div class="back">
          <a (click)="back()">
            <span class="back-btn">
              <fa-icon [icon]="['fas', 'arrow-left']" size="1x"></fa-icon>
            </span>
            {{ "main-menu.button.back" | translate }}
          </a>
        </div>
      }
      <!-- Menu Section -->
      <div class="menus">
        <!-- Primary and Secondary Menu -->
        @for (
          menuItems of [menuItems(), menuItemsSecondary()];
          track menuItems;
          let i = $index
        ) {
          @if (menuItems.length > 0) {
            <ul
              class="menu-items"
              [class.filtered]="filtered"
              [class.second]="i > 0"
              [class.menu-items-small]="!isExpanded()"
            >
              @for (menu of menuItems; track menu) {
                <li
                  [class.menu-item]="isExpanded()"
                  [class.menu-item-small]="!isExpanded()"
                  placement="right"
                >
                  <ng-container>
                    <ul class="submenu-items">
                      <div class="header-item" (click)="toggleMenuHeader(menu)">
                        <span>{{ menu.title }}</span>
                        <fa-icon
                          class="submenu-icon"
                          [icon]="
                            !isGroupCollapsed(menu)
                              ? ['fas', 'caret-up']
                              : ['fas', 'caret-down']
                          "
                        ></fa-icon>
                      </div>
                      <ng-container>
                        @for (submenu of menu.children; track submenu) {
                          <li
                            [class.should-hide]="isGroupCollapsed(menu)"
                            [class.search-match]="
                              searchString() &&
                              submenu.title
                                ?.toLowerCase()
                                .includes(searchString().toLowerCase())
                            "
                            [class.search-hidden]="
                              searchString() &&
                              !submenu?.title
                                .toLowerCase()
                                .includes(searchString().toLowerCase())
                            "
                            [routerLink]="submenu.link"
                            [routerLinkActive]="['active']"
                            [suiTooltip]="!isExpanded() ? submenu.title : null"
                          >
                            <div class="submenu-item">
                              <fa-icon
                                class="submenu-icon"
                                [icon]="submenu.icon"
                                size="lg"
                                [routerLink]="submenu.link"
                              ></fa-icon>
                              <a
                                class="title"
                                [innerHTML]="
                                  submenu.title | highlight: searchString()
                                "
                              >
                              </a>
                            </div>
                          </li>
                        }
                      </ng-container>
                    </ul>
                  </ng-container>
                </li>
              }
            </ul>
          }
        }
      </div>
    </div>
  </div>
}
